<div class="row form" *ngIf="book != null">
  <app-loading-modal></app-loading-modal>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-4">
          <h4 class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Detalle reserva</h4>
        </div>
        <div class="col-sm-8 form__head__boxBtn">
          <button type="button" class="btn btn-secondary btn-sm hide-xs" (click)="cancel()"><i
              class="fas fa-arrow-left m-r-5"></i> Regresar
          </button>
          <!-- <a type="button" class="btn btn-danger btn-sm text-white" (click)="checkOut()"
            *ngIf="book.is_checkin == true && book.is_checkout == false">
            <i class="fas fa-arrow-down m-r-2"></i> ANULAR
          </a> -->
          <!-- <a type="button" class="btn btn-info text-white btn-sm" (click)="recover()"
            *ngIf="book.is_checkin == true && book.is_checkout == true">
            <i class="fas fa-undo m-r-2"></i> Recuperar
          </a> -->
          <button type="button" class="btn btn-success btn-sm" (click)="bookingAmortization(book, matrix_module)"
            *ngIf="book.total != book.total_paid" data-toggle="modal" data-target="#openExtendsAmortization">
            <i class="fas fa-money-bill-alt m-r-3"></i>Amortizar
            {{toolsService.momeySol()}}{{(book.total - book.total_paid).toFixed(2)}}
          </button>
          <button class="btn btn-sm btn-primary" (click)="edit(book.id)"><i
              class="fas fa-pen-alt m-r-2"></i>Editar
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-50" id="body">
      <div class="card-body faq-box boder-left-dark">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Código reserva</div>
                <div class="child-right">
                  <span class="bold">{{book.code}}
                    <i *ngIf="book.is_favorite" class="fas fa-star m-l-2 color-favorite"></i>
                  </span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left bold">Responsable</div>
                <div class="child-right">
                  {{book.client_data.fullname}}
                  <p class="bold f-s-10 m-b-0">{{book.client_data.typeDocument}} :
                    {{book.client_data.document}}</p>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Teléfonos</div>
                <div class="child-right">
                  {{book.client_data.cellphone}}
                  <span class="m-l-5" ng-if="book.client_data.telephone != null">
                    - {{book.client_data.telephone}}
                  </span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Código vuelo</div>
                <div class="child-right">
                  {{book.code_flight}}
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">N° Pasajeros</div>
                <div class="child-right">
                  {{book.nro_passengers}}
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">R.Usuario</div>
                <div class="child-right">
                  <span class="text-uppercase">{{book.user_data.username}} </span>
                  <ng-container *ngIf="book.user_updated_id != null">
                    <span class="m-l-10 f-s-10">(última actualización usuario: {{book.user_updated_data.username}}
                      {{book.updated_at | date: 'short'}} )</span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="!book.is_book_hotel">
          <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-map-marker-alt m-r-5"></i>Datos de tours
          </p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th class="text-left w-20">
                    Apto.Salida
                    <i class="m-l-3 fas fa-plane-departure"></i>
                  </th>
                  <th class="w-10 text-center">Fecha.Salida</th>
                  <th class="w-10 text-center">Hora.Salida</th>

                  <th class="text-left w-20">
                    Apto.Llegada
                    <i class="m-l-3 fas fa-plane-arrival"></i>
                  </th>
                  <th class="w-10 text-center">Fecha.Llegada</th>
                  <th class="w-10 text-center">Hora.LLegada</th>
                  <th class="nowrap text-center w-15">
                    aerolinea
                  </th>
                  <th class="nowrap text-center w-10">N°.vuelo</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="section_flights.length == 0">
                  <tr>
                    <td colspan="4"><span>No se encontraron registros</span></td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="section_flights.length > 0">
                  <tr *ngFor="let item of section_flights; let index_ = index">
                    <td class="text-left w-20">
                      {{item.departure_airport.name}}
                    </td>
                    <td class="w-10 text-center">
                      {{item.date_departure}}
                    </td>
                    <td class="w-10 text-center">
                      {{item.time_departure}}
                    </td>
                    <td class="text-left w-20">
                      {{item.arrival_airport.name}}
                    </td>
                    <td class="w-10 text-center">
                      {{item.date_arrival}}
                    </td>
                    <td class="w-10 text-center">
                      {{item.time_arrival}}
                    </td>
                    <td class="nowrap text-center w-15">
                      {{item.tourismairlines.description}}
                    </td>
                    <td class="w-10 text-center">
                      {{item.number_flight}}
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>          
        </div>

        <div class="col-12 m-t-20">
          <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-money-bill-alt m-r-5"></i>Comprobantes y
            cobros realizados</p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th>R.Usuario</th>
                  <th>Tipo comprobante</th>
                  <th>N° comprobante</th>
                  <th>Fecha</th>
                  <th class="w-15 text-center">Método pago</th>
                  <th class="w-15 text-right">Pagado</th>
                  <th class="w-15 text-center">Comprobante</th>
                  <th class="w-15 text-center">constancia</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="movements.length == 0">
                  <tr>
                    <td colspan="7">No registra datos de cobros.</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="movements.length > 0">
                  <tr *ngFor="let item of movements; let index_ = index"
                    [ngClass]="{'text-danger': item.date_repayment != null}">
                    <td>{{item.user_data.username}}</td>
                    <td>{{item.typevoucher}}</td>
                    <td>{{item.nro_voucher}}</td>
                    <td>{{item.date_movement  |  date: 'YYYY-MM-dd'}}</td>
                    <td class="w-15 text-center">{{item.paymethod.description}}</td>
                    <td class="w-15 text-right">{{toolsService.momeySol()}}{{item.total_amount}}</td>
                    <td class="w-15 text-center">
                      <div *ngIf="item.date_repayment == null">
                        <ng-container *ngIf="item.booking_id == null">
                          <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                            href="/{{branchofficeSlug}}/api/print/billing/document/{{item.id}}"
                            *ngIf="item.voucher_id == typevoucher_factura.id || item.voucher_id == typevoucher_boleta.id || item.voucher_id == typevoucher_ordernote.id">
                            <i class="fas fa-print f-s-16"></i>
                          </a>
                        </ng-container>
                        <ng-container *ngIf="item.booking_id != null">
                          <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                            href="/{{branchofficeSlug}}/api/print/billing/document/booking/{{item.id}}"
                            *ngIf="item.voucher_id == typevoucher_factura.id || item.voucher_id == typevoucher_boleta.id || item.voucher_id == typevoucher_ordernote.id">
                            <i class="fas fa-print f-s-16"></i>
                          </a>
                        </ng-container>
                        <a title="{{item.typevoucher}}" class="text-warning pointer bold" target="_blank"
                          href="/{{branchofficeSlug}}/api/print/income/document/{{item.id}}"
                          *ngIf="item.voucher_id == typevoucher_income.id || item.voucher_id == typevoucher_expense.id">
                          <i class="fas fa-print f-s-16"></i>
                        </a>
                      </div>
                      <div *ngIf="item.date_repayment != null">
                        <span class="badge badge-danger f-s-10">Comprobante de baja</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span *ngIf="item.url_image != null">
                        <a class="text-info pointer bold" href="tenants/{{item.url_image}}" download>
                          <i class="fas fa-file-download f-s-16"></i>
                        </a>
                      </span>
                      <!-- <span *ngIf="item.url_image == null">
                          <a class="text-dark pointer" title="Subir constancia" data-toggle="modal" 
                            data-target="#openExtendsUploadFileMovement" (click)="UploadFileMovementsExtendsComponent.init(item)">
                            <i class="fas fa-upload f-s-16"></i>
                          </a>
                        </span> -->
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <!-- <div class="col-12 m-t-20">
          <button type="button" class="btn btn-light waves-effect waves-light" (click)="getAuditing()">
            Registro Auditoría <i class="far fa-clock m-l-5"></i>
          </button>
        </div> -->
      </div>
    </div>
  </div>
  <!-- sample modal content -->
  <div id="modalAuditing" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title mt-0">Registro auditoría cambios | Reserva <span class="bold">{{book.code}}</span></h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="max-height: 500px;overflow-y: auto;">
          <div class="table-responsive">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>Fecha y Hora</th>
                  <th>Usuario</th>
                  <th>Evento</th>
                  <th>Alias</th>
                  <th class="text-center">Detalles</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let audit of filteredAuditsBooking; let i = index">
                  <tr>
                    <td>{{ audit.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                    <td>{{ audit.user || 'Desconocido' }}</td>
                    <td>{{ audit.event }}</td>
                    <td>
                      {{ audit.alias }}
                      <ng-container *ngIf="audit.model === 'ToursBooking'">
                        <p class="m-t-2 m-b-0 f-s-10"><span class="bold">Item</span>:{{ audit.tour_name }}</p>
                      </ng-container>
                    </td>
                    <!-- <td>{{ audit.device_name }}</td> -->
                    <td class="text-center">
                      <button class="btn btn-sm f-s-10" [ngClass]="expandedIndex === i ? 'btn-dark' : 'btn-info'"
                        (click)="toggleDetails(i, audit)">
                        {{ expandedIndex === i ? 'Ocultar' : 'Ver detalles' }}
                        <ng-container *ngIf="expandedIndex === i">
                          <i class="fas fa-arrow-up"></i>
                        </ng-container>
                        <ng-container *ngIf="expandedIndex !== i">
                          <i class="fas fa-arrow-down"></i>
                        </ng-container>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="expandedIndex === i">
                    <td colspan="6" style="padding: 0px !important;">
                      <div class="card m-b-5" style="background: #fffbfb;">
                        <div class="card-body p-l-10 p-r-10 p-t-5 p-b-5">
                          <h5 class="m-t-10 f-s-15 text-underline">Detalles de la Auditoría</h5>
                          <ul>
                            <li><strong>Usuario:</strong> {{ selectedAudit?.user }}</li>
                            <li><strong>Acción:</strong> {{ selectedAudit?.event }}</li>
                            <li><strong>Fecha:</strong> {{ selectedAudit?.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                            </li>
                            <ng-container *ngIf="selectedAudit?.model === 'ToursBooking'">
                              <li><strong>Item:</strong> {{ selectedAudit?.tour_name }}</li>
                            </ng-container>
                          </ul>
                          <h6 style="color: red;">Valores Anteriores</h6>
                          <ul>
                            <li *ngFor="let key of objectKeys(selectedAudit?.old_values)">
                              <strong>{{ key }}:</strong> {{ selectedAudit?.old_values[key] }}
                            </li>
                          </ul>
                          <h6 style="color: green;">Valores Nuevos</h6>
                          <ul>
                            <li *ngFor="let key of objectKeys(selectedAudit?.new_values)">
                              <strong>{{ key }}:</strong> {{ selectedAudit?.new_values[key] }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-amortization-extends (onSubmitEvent)="beforeAmortization($event)"></app-amortization-extends>